module.exports = __webpack_public_path__ + "img/reference23.aa678fcf.jpg";